import React, { Suspense } from "react";
import DiscountBanner, { TopBannerProps } from "./DiscountBanner";
import Line from "./Line";

const SuspenseDiscountBanner: React.FC<TopBannerProps> = (props) => (
  <Suspense fallback={<Line text={" "} />}>
    <DiscountBanner {...props} />
  </Suspense>
);

export default SuspenseDiscountBanner;
